<section class="login-stage">
  <div class="login-shell container">
    <div class="login-grid single-card-layout">
      <div class="login-card">
        <form (ngSubmit)="submitForm()" [formGroup]="loginForm" novalidate>
          <div class="justify-content-center text-center">
            <h3> Acesso ao Sistema</h3>
            <p class="form-subtitle">Identifique-se para continuar</p>
          </div>
          <div class="form-field">
            <label for="username">Usuario</label>
            <div class="input-wrap">
              <i class="bi bi-person"></i>
              <input type="email" id="username" formControlName="username" class="form-control"
                placeholder="seu.email@dominio.com" autocomplete="username">
            </div>
          </div>

          <div class="form-field">
            <label for="password">Senha</label>
            <div class="input-wrap">
              <i class="bi bi-shield-lock"></i>
              <input type="password" id="password" formControlName="password" class="form-control"
                placeholder="********" autocomplete="current-password">
            </div>
          </div>

          <button class="btn login-submit w-100" type="submit">
            <fa-icon [icon]="['fas', 'key']" class="me-2"></fa-icon>
            Entrar no sistema
          </button>

          @if (isAutenthicationError) {
          <div class="login-error">
            {{ error }}
          </div>
          }
        </form>
      </div>
    </div>
  </div>
</section>